import React, { useCallback, useEffect, useState } from "react";
import Headar from "../Component/Headar";
import BannerSection from "../Component/BannerSection";
import MobileHader from "../Component/MobileHader";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../Component/Footer";
import ShapeImg from "../aseets/img/curve.png";
import { InfinitySpin } from "react-loader-spinner";
import FooterImg from "../aseets/img/I2.png";
import axios from "axios"; // Import axios for making HTTP requests
import BradCrum from "../Component/BradCrum";
// import BradCrumImg from "../aseets/img/contactusImg.png";
import { useDropzone } from "react-dropzone";
const ContactUs = () => {
  const [isLoading, setIsLoading] = useState(true);
  // State for each file section
  const [bioDataFile, setBioDataFile] = useState(null); // For "Upload Bio Data"
  const [photoFile, setPhotoFile] = useState(null); // For "Upload Your Photo"

  // Dropzone for Bio Data Upload
  const {
    getRootProps: getBioDataRootProps,
    getInputProps: getBioDataInputProps,
    isDragActive: isBioDataDragActive,
  } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
    },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setBioDataFile(file);
      }
    },
  });

  // Dropzone for Photo Upload
  const {
    getRootProps: getPhotoRootProps,
    getInputProps: getPhotoInputProps,
    isDragActive: isPhotoDragActive,
  } = useDropzone({
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
    },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setPhotoFile(file);
      }
    },
  });

  useEffect(() => {
    // Simulate a delay of 2 seconds (adjust as needed)
    const delay = 1000;
    setTimeout(() => {
      setIsLoading(false);
    }, delay);
  }, []);

  // const { getRootProps, getInputProps, isDragActive } = useDropzone({
  //   //  onDrop
  //   accept: {
  //     "image/*": [".png", ".jpg", ".jpeg"], // Allow image files only
  //     "application/pdf": [".pdf"], // Allow PDFs
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
  //       [".docx"], // Allow DOCX
  //   },
  //   onDrop: (acceptedFiles) => {
  //     const file = acceptedFiles[0]; // Get the first file
  //     if (file) {
  //       setSelectedFile({
  //         name: file.name,
  //         preview: URL.createObjectURL(file), // Creates a preview URL
  //       });
  //     }
  //   },
  // });
  // Yup validation schema
  // const validationSchema = Yup.object({
  //   Fname: Yup.string()
  //     .min(2, "Name should be at least 2 characters")
  //     .max(50, "Name should be less than 50 characters")
  //     .required("Name is required"),
  //   Lname: Yup.string()
  //     .min(2, "Name should be at least 2 characters")
  //     .max(50, "Name should be less than 50 characters")
  //     .required("Name is required"),
  //   email: Yup.string()
  //     .email("Invalid email address")
  //     .required("Email is required"),
  //     bioDataFile: Yup.mixed()
  //     .required("Bio Data is required")
  //     .test("fileType", "Only PDF or DOCX files are allowed", (value) =>
  //       value ? ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(value.type) : false
  //     )
  //     .test("fileSize", "File size must be less than 2MB", (value) =>
  //       value ? value.size <= 2 * 1024 * 1024 : false
  //     ),
  //     photoFile: Yup.mixed()
  //     .required("Photo is required")
  //     .test("fileType", "Only JPG or PNG files are allowed", (value) =>
  //       value ? ["image/jpeg", "image/png"].includes(value.type) : false
  //     )
  //     .test("fileSize", "File size must be less than 2MB", (value) =>
  //       value ? value.size <= 2 * 1024 * 1024 : false
  //     ),
  //   phone: Yup.string()
  //     .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
  //     .required("Phone number is required"),
  //   message: Yup.string()
  //     .min(10, "Message should be at least 10 characters")
  //     .max(500, "Message should be less than 500 characters")
  //     .required("Message is required"),
  // });
  const validationSchema = Yup.object({
    Fname: Yup.string()
      .min(2, "Name should be at least 2 characters")
      .required("First name is required"),
    Lname: Yup.string()
      .min(2, "Name should be at least 2 characters")
      .required("Last name  required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    // phone: Yup.string()
    //   .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    //   .required("Phone number is required"),
    // message: Yup.string()
    //   .min(10, "Message should be at least 10 characters")
    //   .required("Message is required"),
      Gender: Yup.string()
      .required("This fild is required"),
      DOB: Yup.string()
      .required("This fild is required"),

  });

  const handleSubmit = async (values, { resetForm }) => {
    // if (!bioDataFile) {
    //   alert("Please upload your Bio Data");
    //   return;
    // } else if (!photoFile) {
    //   alert("Please upload your photo");
    //   return;
    // }
    try {
      const formData = new FormData();
      formData.append("FirstName", values.Fname);
      formData.append("LastName", values.Lname);
      formData.append("Email", values.email);
      formData.append("Phone", values.phone);
      formData.append("HereFrom", values.message);
      formData.append("bioData", bioDataFile);
      formData.append("image", photoFile);
      formData.append("IsActive", true);

      const apiUrl = `${process.env.REACT_APP_API_URL}/api/auth/create/ReachUs`;

      await axios.post(apiUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Form submitted successfully!");
      resetForm();
      setBioDataFile(null);
      setPhotoFile(null);
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("There was an error sending your message.");
    }
  };
  const [bannerImages, setBannerImages] = useState({});
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/inner-banners`);
        if (response.data && Array.isArray(response.data) && response.data.length > 5) {
          setBannerImages(response.data); 
          
        }
      } catch (error) {
        console.error('Error fetching banner images:', error);
      }
    };

    fetchBannerImages();

    
  }, []);

  return (
    <React.Fragment style={{ backgroundColor: "#fff" }}>
      {isLoading ? (
        // Loader component while loading
        <div className="loader-container">
          <InfinitySpin
            color="#000"
            height={50}
           width="200"
            timeout={0} // 0 means no timeout, loader will be displayed until setIsLoading(false) is called
          />
        </div>
      ) : (
        <div>
          <Headar />
          <MobileHader />
          <BradCrum
            Title={bannerImages[5]?.Title}
            ShapeImg={ShapeImg}
            BradCrumImg={`${process.env.REACT_APP_API_URL}/${bannerImages[5]?.bannerImage}`}
            color="#fff"
          />
          {/* <BannerSection /> */}
          <Container className="contactUsDivContainer">
          <div className="contactUsDiv">
            <div className="contactUsMainDiv">
              <div className="missonTite contactTitle">
                Get in touch with us & let’s talk
              </div>
              <div className="contactUsDescription">
                Platinum Matches offers a complimentary 30 minute consultation
                to parents and/or prospects via phone to learn about our
                services.
              </div>
              <div className="contacutUsTitleMainDiv">
                <div className="contactUsSubTitle">
                  To sign up, please complete the Complimentary Consult Form
                  below.
                </div>
              </div>
            </div>
          </div>
          
            <Formik
              initialValues={{
                Fname: "",
                Lname: "",
                email: "",
                phone: "",
                message: "",
                image: "",
                biodata: "",
                Gender:"",
                DOB:""
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form className="contacusForm">
                  <Row>
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <div className="formLable">
                          <label>
                            First Name <span>*</span>
                          </label>
                        </div>
                        <Field
                          type="text"
                          id="Fname"
                          name="Fname"
                          className="inputFild"
                          // placeholder="Your Name"
                        />
                        <ErrorMessage
                          name="Fname"
                          component="div"
                          className="error"
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <div className="formLable">
                          <label>
                            Last Name <span>*</span>
                          </label>
                        </div>
                        <Field
                          type="text"
                          id="Lname"
                          name="Lname"
                          className="inputFild"
                          // placeholder="Your Name"
                        />
                        <ErrorMessage
                          name="Lname"
                          component="div"
                          className="error"
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="formLable" htmlFor="email">
                          Email <span>*</span>
                        </label>
                        <Field
                          type="email"
                          id="email"
                          name="email"
                          className="inputFild"
                          // placeholder="Your Email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="error"
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="formLable" htmlFor="phone">
                          Phone Number 
                        </label>
                        <Field
                          type="text"
                          id="phone"
                          name="phone"
                          className="inputFild"
                          // placeholder="Your Phone Number"
                        />
                        {/* <ErrorMessage
                          name="phone"
                          component="div"
                          className="error"
                        /> */}
                      </div>
                    </Col>
                    <Col className="mb-3" lg={12} md={12}>
                      <div className="formLable">
                        <label>
                          Gender <span>*</span>
                        </label>
                      </div>
                      <div className="radioMainDiv contauctUsDivRadio">
                        <div className="radioDiv inputFild">
                          <Field type="radio" name="Gender" value="Male" /> Male
                        </div>
                        <div className="radioDiv inputFild">
                          <Field type="radio" name="Gender" value="Female" />{" "}
                          Female
                        </div>
                      </div>

                      <ErrorMessage
                        name="Gender"
                        component="div"
                        className="error"
                      />
                    </Col>
                    <Col className="mb-3" lg={12} md={12}>
                      <div className="formLable">
                        <label>
                          Date of Birth <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild" type="date" name="DOB" />
                      <ErrorMessage
                        name="DOB"
                        component="div"
                        className="error"
                      />
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="formLable" htmlFor="message">
                          Where did you hear about us? 
                        </label>
                        <Field
                          as="textarea"
                          id="message"
                          name="message"
                          className="inputFild"
                          // placeholder="Your Message"
                        />
                        {/* <ErrorMessage
                          name="message"
                          component="div"
                          className="error"
                        /> */}
                      </div>
                    </Col>

                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <div {...getBioDataRootProps()}>
                          <label className="formLable" htmlFor="bioData">
                            Upload Bio Data 
                          </label>
                          <div className="imgUplodadDiv">
                            <input {...getBioDataInputProps()} />
                            {isBioDataDragActive ? (
                              <p>Drop the files here ...</p>
                            ) : (
                              <p>Click to upload. Supported: PDF, DOCX</p>
                            )}
                          </div>
                          {bioDataFile && (
                            <div
                              style={{ marginTop: "20px", textAlign: "center" }}
                            >
                              <p>Selected File: {bioDataFile.name}</p>
                            </div>
                          )}
                        </div>
                        {/* <ErrorMessage
                          name="image"
                          component="div"
                          className="error"
                        /> */}
                      </div>
                    </Col>

                    {/* Upload Photo Section */}
                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <div {...getPhotoRootProps()}>
                          <label className="formLable" htmlFor="photo">
                            Upload Your Photo 
                          </label>
                          <div className="imgUplodadDiv">
                            <input {...getPhotoInputProps()} />
                            {isPhotoDragActive ? (
                              <p>Drop the files here ...</p>
                            ) : (
                              <p>Click to upload. Supported: JPG, PNG</p>
                            )}
                          </div>
                          {photoFile && (
                            <div
                              style={{ marginTop: "20px", textAlign: "center" }}
                            >
                              <p>Selected File: {photoFile.name}</p>
                              {/* <img
                                src={photoFile.preview}
                                alt="Uploaded Preview"
                                style={{
                                  width: "200px",
                                  height: "auto",
                                  marginTop: "10px",
                                }}
                              /> */}
                            </div>
                          )}
                        </div>
                        {/* <ErrorMessage
                          name="image"
                          component="div"
                          className="error"
                        /> */}
                      </div>
                    </Col>

                    <button type="submit" className="submitBtn">
                      Submit
                    </button>
                  </Row>
                </Form>
              )}
            </Formik>
          </Container>
          <div>
            <img src={FooterImg} alt="img" />
          </div>
          <Footer />
        </div>
      )}
    </React.Fragment>
  );
};

export default ContactUs;
